const lan = {
  REDIRECT: "Uudelleenohjataan...",
  RULE: {
    SERVICE_TYPE: "Valitse palvelutyyppi",
    COUNTRY: "Valitse maasi tai alueesi",
    USERNAME: "Käyttäjänimi vaaditaan",
    EMAIL: "Sähköpostiosoite vaaditaan",
    EMAIL2: "Anna oikea sähköpostiosoitteen muoto.",
    PRODUCT: "Valitse laitteesi",
    PRODUCTSN: "Anna tuotteesi sarjanumero",
    PRODUCTSN_LEN: "Anna 12–15 kirjainta tai numeroa",
    BIRTHDAY: "Syntymäpäivä vaaditaan",
    REQUIRED: "Vaaditaan",
  },
  SYS: {
    HEAD: "Järjestelmä",
    NOSERVICE:
      "Valitettavasti ASUS Chat ei ole saatavilla valitsemallesi maalle tai alueelle.",
    CHECK_FILESIZE:
      "Tarkista kuvan tai liitteen koko. Rajoitus:",
    RECONNECTED: "Yhteystila on palannut normaaliksi",
    UNABLE_SEND: "Liitteitä ei voi lähettää",
    NO_NETWORK: "Ei internet-yhteyttä",
    NO_NETWORK_INFO:
      "Ei internet-yhteyttä. Muodosta yhteys internetiin ja yritä uudelleen.",
  },
  IDLE: {
    HEAD: "Olet ollut jonkin aikaa käyttämättömänä. Haluatko jatkaa chattia?",
    BUTTON: "Jatka",
  },
  DISCONNECT: {
    HEAD: "Chat on päättynyt",
    BUTTON: "Lopeta",
  },
  LAYOUT: {
    STEP_1: "Valitse tuote",
    STEP_2: "Käyttöehdot",
    STEP_3: "Kirjaudu sisään",
    STEP_4: "Tiedot",
    SELECT_SKILL: "Valitse tuote",
    PREV_STEP: "Edellinen",
    NEXT_STEP: "Seuraava",
    NOTSET: "Ei asetettu.",
    AGREEN: "Hyväksyn",
    NOTAGREEN: "En hyväksy",
    LEAVE: "Poistu",
    TYPE_HERE: "Kirjoita tähän",
    CHAT_DOWNLOAD:
      "Napsauta tästä tallentaaksesi kopion chatistasi ASUS-asiakaspalvelun kanssa.",
  },
  COUNTRY: { SELECT_COUNTRY: "Valitse palvelun maa tai alue" },
  POLICY: {
    PRIVACY: "Tietosuojakäytäntö",
    SAT_SURVEY: "Palvelusopimus",
    CONFIRM_COUNTRY: {
      H1: "Hyvä ASUS-asiakas,",
      P1:
        "Olet nyt ASUS-asiakaspalvelussa Pohjoismaissa, joka eroaa nykyisestä alueestasi. ASUS-takuuehtojen mukaan kaikki ASUS-tuotteet eivät ole oikeutettuja ASUSin kansainvälisiin takuu- ja tukipalveluihin. Jos yllä oleva alueellinen verkkosivusto, jolla vierailet, ei ole alue, josta ostit ASUS-tuotteesi, tai se eroaa nykyisestä alueestasi, tämä voi vaikuttaa oikeuksiisi. Voit jatkaa ASUSin online-asiakaspalvelun käyttöä Suomessa tai muuttaa ASUSin online-asiakaspalvelun alueellesi.",
      P2: "",
      P3: "",
      B1: "Vaihda ASUSiin",
      B2: "Kotisivu",
      B3: "Jatka käyttöä",
    },
    BULLETIN: {
      HEAD: "Ilmoitus tärkeästä viestistä",
      CONFIRM: "Ymmärrän",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Täytä yhteystietosi",
    SURVEY_TYPE: "Valitse palvelutyyppi",
    PROBLEM_BRIEF: "Miten kuvailisit ongelmaasi?",
    TYPE1: "Yleinen kysymys",
    TYPE2: "Korjauspyyntö",
    TYPE3: "Tekninen tuki",
    TYPE4: "Takuupyyntö",
    TYPE5: "Mielipiteet ja palaute",
    EC_TYPE1: "Tuote- ja myyntitiedot",
    EC_TYPE2: "Markkinointitapahtuma",
    EC_TYPE3: "Toimitus- ja tilaustila",
    EC_TYPE4: "Palautuspalvelu",
    SIGNUPDATA: "Rekisteröintitietosi",
    NAME: "Nimi",
    TEL: "Puhelinnumero",
    ORDER_NO: "Tilausnumero",
    BIRTHDAY: "Syntymäpäivä",
    LABEL_EMAIL: "Sähköposti",
    EMAIL: "Sähköposti",
    DEVICEINFO: "Tuotetietosi",
    DEVICENAME: "Tuotteen nimi",
    MY_DEVICE: "Tuotteesi",
    MY_DEVICE_SELECT: "Valitse tuotteesi",
    MY_DEVICE_EMPTY: "Sinulla ei ole vielä laitteita.",
    LABEL_DEVICESN: "Sarjanumero",
    DEVICESN: "Tuotteen sarjanumero",
    DEVICESN_ERROR: "Antamasi sarjanumero on virheellinen.",
    PREPARE: "Luodaan chattihuonetta, valmistaudutaan chattiin",
    START: "Aloita chat",
    AGE_LIMIT: "Ikäraja",
    AGE_LIMIT_DESC: "Et täytä ASUS Chatin käyttöön vaadittavia ikävaatimuksia",
    REPEAT_ENTRY: {
      H1: "Olemassa oleva chattihuone havaittu",
      P1:
        "Haluatko varmasti aloittaa uuden keskustelun? Kun uusi keskustelu avataan, vanha keskustelu päättyy.",
      B0: "Vahvista",
      B1: "Peruuta",
    },
  },
  CONNECTTING: {
    P1: "Odota hetki äläkä sulje chat-ikkunaa",
    P2: "ASUS Chat yhdistää sinut vapaana olevaan edustajaan",
    NOTE: "Vihje",
    BEFORE_LEAVE: "Haluatko varmasti lopettaa ASUS Chatisi?",
    B0: "Lopeta",
    B1: "Jää odottamaan",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Ota yhteyttä ASUKseen muiden kanavien kautta",
    MAIL: "Lähetä meille sähköpostia",
    TEL: "Soita meille",
    CLOSE: "Sulje",
  },
  WAITTING: {
    WATTING_NUM: "Sija jonossa",
    PEOPLE: "Asiakas",
    NOTE: "Vihje",
    BEFORE_LEAVEL: "Haluatko varmasti poistua jonosta?",
    LEAVE_DESC: "Jos haluat poistua jonosta, voit lopettaa chatin",
    LEAVE: "Lopeta chat",
    STAY: "Pysy jonossa",
  },
  CHATROOM: {
    TYPING: "Edustaja kirjoittaa...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Poistu chatista",
      TERMINATE: "Lopeta chat",
    },
    FOOTER: { CHAT_FINISH: "Chat on päättynyt" },
    FINISH:
      "Chat on päättynyt. Tarvitsetko lisäpalvelua tai tukea?",
    SAT_SURVEY: {
      SAT: "Tyytyväinen",
      DISSAT: "Tyytymätön",
      SAT_CHOOSE: "Minkä tyyppisiä palveluita? (useita)",
      HEAD: "Olitko tyytyväinen chattiin?",
      DESC:
        "Palautteesi kuunteleminen on jatkuvan parantamisen liikkeellepaneva voima. Kerro meille, jos sinulla on ehdotuksia ASUS-palveluille tai -tuelle.",
      OTHER_OPTION: "Muu",
      OTHER_REASON: "Täytä muu syy",
      SEND: "Lähetä",
    },
    CLOSE: {
      TITLE: "Haluatko varmasti lopettaa chatin?",
      P1:
        'Napsauta "Lopeta" sulkeaksesi ikkunan. Jos sinun on käytettävä chattia uudelleen, napsauta "Aloita uusi chat".',
      B0: "Lopeta",
      B1: "Peruuta",
    },
  },
  ERROR: {
    H1: "Chattihuonetta ei ole olemassa tai chat on jo päättynyt",
    CLOSE: "Sulje ikkuna",
  },
  CHAT_END: {
    H1: "Kiitos paljon, chat on nyt päättynyt",
    CLOSE: "Sulje ikkuna",
  },
  CHAT_CLOSE: {
    H1:
      "Verkkoyhteytesi on ollut poissa yli 300 sekuntia, joten olemme lopettaneet tämän keskustelun.",
    DESC:
      "Jos käytät langatonta tai mobiiliverkkoa, siirry paikkaan, jossa on vahvempi signaali, tai vaihda langalliseen verkkoyhteyteen. Olemme pahoillamme mahdollisesta haitasta",
    CLOSE: "Sulje ikkuna",
  },
  SURVEY_DONE: {
    H1: "Kiitos. Olet suorittanut palvelutyytyväisyyskyselyn",
    P1:
      'Palautteesi on jatkuvan parantamisen liikkeellepaneva voima. Kiitos, että käytit aikaa palvelutyytyväisyyskyselyn täyttämiseen. Jos tarvitset lisäpalvelua tai tukea, napsauta "Aloita uusi chat". Napsauta "Sulje ikkuna" lopettaaksesi chatin, jos olemme ratkaisseet kysymyksesi',
    AGAIN: "Aloita uusi chat",
    CLOSE: "Sulje ikkuna",
    YT_H1: "Tutustu vinkkeihin ja tekniseen tietotaitoon ASUS-tukivideoiden avulla.",
    YT_H2: "Napsauta tutkiaksesi!",
  },
  AGENT_OFFLINE: {
    H1:
      "Edustajan Internet-yhteys ei vastaa; chattisi on tällä hetkellä keskeytynyt",
    H2:
      "Älä sulje ikkunaa; pyrimme kovasti jatkamaan chattia",
    DESC:
      'Voit myös päättää lopettaa chatin ja aloittaa kyselyn tai napsauttaa "Aloita uusi chat", ja määritämme välittömästi uuden edustajan jatkamaan chattiasi. Pahoittelemme mahdollista haittaa',
    AGAIN: "Aloita uusi chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Kameraa ja mikrofonia ei voi käyttää",
    H1: "Oletko valmis liittymään?",
    P1:
      "Jotta ASUS-asiakaspalveluhenkilöstö voi auttaa sinua ratkaisemaan ongelman tehokkaammin, sinun on sallittava laitteen käyttää kameraasi ja mikrofonia liittyäksesi videochattihuoneeseen, ja varmista, että mobiiliverkkoyhteytesi on vakaa ja toimii normaalisti",
    P2:
      "Käytön jälkeen voit silti vapaasti asettaa linssikytkimen ja mikrofonin mykistyksen.",
    VIDEO_STATE: "Videon tila",
    VIDEO_ON: "Päällä",
    VIDEO_OFF: "Pois päältä",
    AUDIO_STATE: "Äänen tila",
    AUDIO_ON: "Päällä",
    AUDIO_OFF: "Pois päältä",
    ENTER: "Liity",
    HANGUP: {
      H1: "Katkaise puhelu",
      P1: "Haluatko varmasti katkaista videochatin?",
      CONFIRM: "Vahvista",
      CANCEL: "Peruuta",
    },
    END: {
      H1: "Videopuhelu on päättynyt",
      P1: "Kiitos, tämä videochat on ohi, voit sulkea tämän ikkunan.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Valitse tuote",
      STEP_2: "Käyttöehdot",
      STEP_3: "Kirjaudu sisään",
      STEP_4: "Tiedot",
      SELECT_SKILL: "Valitse tuote",
      WELCOME: "Tervetuloa",
      AGREE: "Hyväksy",
      START: "Aloita",
      CANCEL: "Peruuta",
      WAIT: "Odota hetki",
      INPUT: "Kirjoita kysymyksesi tähän",
      TRANSFER_TOAGENT: "Siirrä edustajalle.",
      READMORE: "Voit myös tutustua seuraaviin liittyviin usein kysyttyihin kysymyksiin, kiitos.",
      COLLAPSE: "Piilota",
      INPUT_SN: "Anna sarjanumero uudelleen",
      YOU_MAY_ALSO: "Haluat ehkä myös kysyä:",
      FOR_FURTHER: "Lisätietoja on osoitteessa:",
      RECORDING: "Aloita puhuminen...",
      RECORDING_NOT_SUPPORTED:
        "Selaimesi ei tue puheentunnistusta",
      RECORDING_NOT_FOUND:
        "Tallennuslaitetta ei havaittu. Tarkista mikrofoni ja käyttöoikeudet.",
    },
    IS_COMPONENT_SN:
      "Syöte on komponentin sarjanumero, sinun tulee antaa oikea koneen sarjanumero.",
    WARRANTY: {
      SERIES: "Tuotetyyppi",
      MODEL: "Tuotteen nimi",
      SERIALNO: "Tuotteen sarjanumero",
      STATUS: "Takuun tila",
      DATE: "Takuun päättymispäivä",
    },
    HEAD: {
      LEAVE: "Poistu",
      CREATE_NEW: "Aloita alusta",
    },
    ENTRANCE: {
      POLICY: "Tietosuojakäytäntö",
      AGREE: "Napsauta Hyväksy aloittaaksesi keskustelun",
    },
    MESSAGE: {
      WAIT: "Odota hetki, etsimme sinulle ratkaisua.",
    },
    END: "Keskustelu päättyi",
    END_MSG:
      "Olemme iloisia voidessamme tarjota palveluitamme. Ota rohkeasti yhteyttä tulevaa tukea varten.",
    END_SURVEY: "Tyytyväisyyskysely",
    END_SURVEY_MSG:
      "Olemme iloisia voidessamme tarjota palveluitamme. Ota rohkeasti yhteyttä tulevaa tukea varten.",
    BACKHOME: "Käynnistä keskustelu uudelleen",
    SURVEY: {
      DESC: "Arvioi kokemuksesi ASUSin virtuaaliavustajan kanssa.",
      SAT: "Tyytyväinen",
      DISSAT: "Tyytymätön",
      FEEDBACK: "Täytä palautteesi.",
      SEND: "Lähetä",
      BACK: "Peruuta",
    },
    SURVEY_DISLIKE: {
      H1: "Miksi olet tyytymätön vastaukseen?",
      P: "Palautteesi auttaa meitä parantamaan palveluidemme laatua.",
      BUTTON: "Lähetä",
    },
    HISTORY: {
      TITLE: "Historia",
      AGO: "{hours} tuntia sitten",
      CONTINUE: "Jatka chattia",
      CLOSE: "Keskustelu on suljettu.",
      RESTART: "Aloita uudelleen virtuaaliavustajan kanssa",
      NON_SERVICE: "Ei-palveluaika",
      VIEW_HISTORY: "Napsauta nähdäksesi uusimman chattihistorian.",
    },
  },
};
export default lan;
